var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReserv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_53_88)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.30001 11.8C8.90753 11.8 9.40001 11.3075 9.40001 10.7C9.40001 10.0925 8.90753 9.59998 8.30001 9.59998C7.6925 9.59998 7.20001 10.0925 7.20001 10.7C7.20001 11.3075 7.6925 11.8 8.30001 11.8Z",
    fill: "#344054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5591 0.499303C17.9033 0.441481 16.4836 1.5182 16.0119 3.02624C16.4046 3.1172 16.7886 3.22587 17.1645 3.35025C17.4899 2.36384 18.4274 1.66052 19.5172 1.69857C20.8396 1.74475 21.8781 2.85849 21.832 4.18087C21.8125 4.73895 21.5953 5.23924 21.2604 5.63621C21.5672 5.89547 21.857 6.16858 22.1324 6.45474C22.6589 5.85273 23.0011 5.08421 23.0312 4.22275C23.1006 2.23557 21.5462 0.568696 19.5591 0.499303Z",
    fill: "#344054",
    stroke: "#344054",
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 13C23 8.14754 18.5589 4.2 13.1 4.2C12.1166 4.2 11.1281 4.33935 10.1538 4.61435L7.18716 2.24093C6.98838 2.08211 6.74531 2 6.5 2C6.33792 2 6.17511 2.03558 6.02369 2.10854C5.64239 2.29189 5.4 2.67723 5.4 3.1V7.50073C4.7785 8.18273 4.28535 8.919 3.92561 9.7H2.1C1.49242 9.7 1 10.1924 1 10.8V15.2C1 15.8076 1.49242 16.3 2.1 16.3H3.93369C4.36157 17.2405 4.96657 18.1051 5.72265 18.8582C5.51331 19.2487 5.4 19.6902 5.4 20.15C5.4 21.6665 6.63385 22.9 8.15 22.9C9.17558 22.9 10.0721 22.3353 10.5447 21.5008C11.3778 21.6995 12.2332 21.8 13.1 21.8C13.9668 21.8 14.8222 21.6995 15.6553 21.5008C16.1279 22.3353 17.0244 22.9 18.05 22.9C19.5662 22.9 20.8 21.6665 20.8 20.15C20.8 19.6906 20.6867 19.2491 20.4781 18.859C22.0932 17.2541 23 15.1714 23 13ZM18.9285 18.7578C19.3909 19.0504 19.7 19.5626 19.7 20.15C19.7 21.0611 18.9612 21.8 18.05 21.8C17.1388 21.8 16.4 21.0611 16.4 20.15C16.4 20.1445 16.4015 20.1397 16.4015 20.1346C15.3814 20.4965 14.2686 20.7 13.1 20.7C11.9314 20.7 10.8186 20.4965 9.79854 20.1346C9.79854 20.1398 9.8 20.1445 9.8 20.15C9.8 21.0611 9.06115 21.8 8.15 21.8C7.23885 21.8 6.5 21.0611 6.5 20.15C6.5 19.5626 6.80912 19.0504 7.27146 18.7578C6.06034 17.8184 5.15508 16.5904 4.67838 15.2H2.1V10.8H4.66923C5.03481 9.72565 5.67792 8.76281 6.5 7.94112V3.1L9.92246 5.83788C10.9106 5.50127 11.9754 5.3 13.1 5.3C17.9602 5.3 21.9 8.74738 21.9 13C21.9 15.2939 20.7472 17.3472 18.9285 18.7578Z",
    fill: "#344054",
    stroke: "#344054",
    strokeWidth: 0.45
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_53_88"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReserv);
export default __webpack_public_path__ + "static/media/reserv.d814db9ac04a1d95af6c3cd225feb9ef.svg";
export { ForwardRef as ReactComponent };